import { Nullable } from '../../interfaces/common/i-generics';
import { MongoRecord } from '../mongo/_base';

export enum VisionDetectionType {
  Missed = 'missed',
  ShadowLocalizerMismatch = 'shadow-localizer-mismatch',
}

// just so we can show the pitch name in the UI without querying the pitches table
export interface IVisionDetectionPitch {
  id: string;
  name: string;
}

// fields common to every vision detection, regardless of type
export interface IVisionDetectionBase extends MongoRecord {
  machineID: string;
  type: VisionDetectionType;
}

export interface IMissedVisionDetection extends IVisionDetectionBase {
  type: VisionDetectionType.Missed;

  fireEventID: string;

  pitch?: Nullable<IVisionDetectionPitch>;
  debug_img_s3_path?: Nullable<string>;

  // customer support instructions or general details about the (missed) detection
  message?: Nullable<string>;
}

export interface IShadowLocalizerMismatchDetection extends IVisionDetectionBase {
  type: VisionDetectionType.ShadowLocalizerMismatch;

  fireEventID?: Nullable<string>;

  [key: string]: unknown;
}

export type IVisionDetection =
  | IMissedVisionDetection
  | IShadowLocalizerMismatchDetection;
